/*
 * Public API Surface of p-table-responsive-scroll
 */

export * from './lib/responsive-scroll/responsive-scroll.module';
export * from './lib/responsive-scroll/responsive-scroll.directive';
